module.exports = __webpack_public_path__ + "static/img/bg-pt.291a924f.png";